import { useEffect, useState } from "react";
import getToken from "../../../getters/getToken";
import useAlerts from "../../../hooks/useAlerts";
import useRejectWithMessage from "../../../hooks/useRejectWithMessage";
import { getLogUpdatedPriceLog } from "../../../requests";
import usePageLogUpdatedPriceContext from "../Provider/hooks/usePageLogUpdatedPriceContext";

type ModalData = { title: string; log: string; fileName: string };
const defaultModalData: ModalData = { title: "", log: "", fileName: "" };
const useModal = () => {
  const { showLog } = usePageLogUpdatedPriceContext();
  const [isLoading, updateStatusLoading] = useState<boolean>(false);
  const [logData, updateModalData] = useState<ModalData>({
    ...defaultModalData,
  });
  const token = getToken();
  const handlerReject = useRejectWithMessage(
    "Ошибка загрузки данных лога",
    () => {
      showLog.update(null);
    }
  );
  const message = useAlerts();
  useEffect(() => {
    if (showLog.value !== null) {
      updateStatusLoading(true);
      getLogUpdatedPriceLog(token, showLog.value)
        .then((modalData) => updateModalData(modalData))
        .catch(handlerReject)
        .finally(() => {
          updateStatusLoading(false);
        });
    }
    return () => {
      updateModalData({ ...defaultModalData });
      updateStatusLoading(false);
    };
  }, [showLog.value]);
  return {
    isOpen: showLog.value !== null && showLog.value > 0,
    isLoading,
    handlerClose: () => {
      showLog.update(null);
    },
    title: logData.title,
    log: logData.log,
    handlerCopy: () => {
      navigator.clipboard
        .writeText(logData.log)
        .then(() => {
          message({
            variant: "success",
            message: "Лог успешно скопирован в буфер обмена",
            autoHideDuration: 5000,
          });
        })
        .catch(() => {
          message({
            variant: "error",
            message: "Ошибка копирования в буфер обмена",
          });
        });
    },
    handlerDownload: () => {
      var blob = new Blob([logData.log], {});
      const a = document.createElement("a");
      a.href = window.URL.createObjectURL(blob);
      a.download = logData.fileName + ".log";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  };
};

export default useModal;
